<template>
  <div class="platform-qa" v-loading="loading">
    <div class="paltform-qa-question-mode" v-show="mode === 'edit'">
      <div class="platform-qa-title">{{ title }}</div>
      <div class="platform-qa-content" v-if="description">
        {{ description }}
      </div>
      <div class="platform-qa-btn-list">
        <a
          v-for="(button, index) in buttons"
          href="javascript:;"
          :key="index"
          class="platform-qa-button"
          :class="
            buttonActiveIndex === index ? 'platform-qa-button--active' : ''
          "
          @click="handleSelect(index, button)"
        >
          {{ button.text }}
        </a>
      </div>
    </div>
    <div class="platform-qa-answer-mode" v-show="mode === 'preview'">
      <div class="platform-qa-title">{{ selectTitle }}</div>
      <span class="paltform-qa-edt-btn" @click="handleUpdate">修改</span>
    </div>
  </div>
</template>

<script type="text/javascript">
import plusService from "@/global/services/jikerPlus";

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    sourceId: {
      type: [Number, String],
      required: true
    },
    projectId: {
      type: [Number, String]
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    buttonActiveIndex: {
      type: [Number, String]
    },
    buttons: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      mode: "",
      selectTitle: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      plusService
        .logQuery({
          source: "kongfu",
          source_id: this.sourceId,
          event: "widget.question",
          "content[widget_id]": this.id
        })
        .then(res => {
          if (res.id) {
            this.mode = "preview";
            this.selectTitle = res.content.title;
          } else {
            this.mode = "edit";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelect(index, data) {
      this.mode = "preview";
      this.selectTitle = data.title;
      const content = {
        source_id: this.sourceId,
        widget_id: this.id,
        select: data.text,
        title: data.title,
        select_index: index
      };
      plusService
        .logs({
          source: "kongfu",
          event: "widget.question",
          source_id: this.sourceId,
          content
        })
        .then(res => {
          if (!res) return;
        });
    },
    handleUpdate() {
      this.mode = "edit";
    }
  }
};
</script>

<style type="text/css" lang="less" scoped>
.platform-qa {
  position: relative;
  padding: 25px;
  text-align: center;
  background: #eaf9f4;
  margin: 20px 0;

  .platform-qa-title {
    font-size: 18px;
    color: #000;
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .platform-qa-content {
    font-size: 14px;
    line-height: 24px;
    color: #666;
    margin-top: 10px;
    white-space: pre-line;
  }

  .platform-qa-btn-list {
    margin-top: 18px;
    text-align: center;
    font-size: 0;

    .platform-qa-button {
      display: inline-block;
      vertical-align: top;
      height: 38px;
      line-height: 38px;
      padding: 0 10px;
      margin: 0 5px;
      font-size: 14px;
      background: rgba(0, 0, 0, 0.85);
      color: #fff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px !important;
      transition: all 0.2s;
      &:hover {
        opacity: 0.8;
      }

      &.platform-qa-button--active {
        background: #35b558;
      }
    }
  }

  .paltform-qa-edt-btn {
    position: absolute;
    right: 12px;
    bottom: 12px;
    font-size: 12px;
    color: #999;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
